var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicle15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "current",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 445 c-7 -19 -14 -39 -14 -45 0 -6 43 -38 95 -72 52 -33 95 -65 95 -70 0 -5 -12 0 -26 11 -36 28 -66 26 -106 -6 -18 -15 -35 -29 -38 -31 -2 -1 2 -7 10 -12 9 -6 17 -5 22 3 5 8 8 4 8 -9 0 -47 62 -70 93 -36 22 25 21 48 -3 72 -11 11 -15 20 -10 20 6 0 18 -13 28 -29 l18 -29 16 29 c10 16 22 29 28 29 5 0 1 -9 -10 -20 -25 -25 -26 -52 -2 -73 24 -22 55 -21 75 1 22 25 21 48 -3 72 -11 11 -15 20 -10 20 6 0 18 -12 28 -27 16 -26 22 -28 87 -28 65 0 71 2 87 28 10 15 22 27 28 27 5 0 1 -9 -10 -20 -25 -25 -26 -52 -2 -73 24 -22 55 -21 75 1 22 25 21 48 -3 72 -11 11 -15 20 -10 20 6 0 18 -13 28 -28 10 -16 24 -26 33 -24 19 3 18 49 -3 130 l-11 42 -88 0 -88 0 -7 35 c-11 62 -19 46 -22 -48 -2 -51 -8 -93 -13 -95 -5 -2 -9 -12 -9 -23 0 -14 -7 -19 -27 -19 -24 1 -26 2 -12 13 13 10 49 96 49 118 0 5 -24 27 -54 49 -50 38 -58 41 -152 50 -154 15 -153 15 -170 -25z m506 -100 c0 -26 -4 -35 -16 -35 -12 0 -15 6 -10 23 3 12 6 28 6 35 0 6 5 12 10 12 6 0 10 -16 10 -35z m89 4 c6 -18 11 -34 11 -35 0 -2 -20 -4 -45 -4 -45 0 -45 0 -45 35 0 33 2 35 34 35 29 0 36 -4 45 -31z m-510 -82 c-2 -1 -13 -9 -24 -17 -19 -14 -19 -14 -6 3 7 9 18 17 24 17 6 0 8 -1 6 -3z m41 -32 c20 -24 3 -57 -28 -53 -30 3 -41 30 -22 53 16 19 34 19 50 0z m140 0 c20 -24 3 -57 -28 -53 -30 3 -41 30 -22 53 16 19 34 19 50 0z m280 0 c20 -24 3 -57 -28 -53 -30 3 -41 30 -22 53 16 19 34 19 50 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 216 c0 -9 7 -16 16 -16 17 0 14 22 -4 28 -7 2 -12 -3 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 223 c-11 -11 -6 -23 9 -23 8 0 15 4 15 9 0 13 -16 22 -24 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526 223 c-11 -11 -6 -23 9 -23 8 0 15 4 15 9 0 13 -16 22 -24 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 425 c0 -10 7 -15 18 -13 21 4 19 22 -2 26 -10 2 -16 -3 -16 -13z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle15);
export default __webpack_public_path__ + "static/media/vehicle15.da024e6a1fb14bcd8bfdb97457fd5e28.svg";
export { ForwardRef as ReactComponent };